/**
 * Register as early as possible so 403 responses don't trigger the CRA error overlay.
 * Must be imported first in index.tsx.
 */
export {};

if (typeof window !== "undefined") {
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const status = event.reason?.response?.status;
      if (status === 403) {
        event.preventDefault();
        event.stopImmediatePropagation?.();
        if (process.env.NODE_ENV === "development") {
          console.warn(
            "[API] 403 Forbidden:",
            event.reason?.config?.url ?? event.reason?.message
          );
        }
      }
    },
    true
  );
}
